/**
 * Program-selection sentinels for the two-stage create reveal (design FR-5).
 *
 * The form needs to tell three states apart, and before this change it could only tell two:
 *
 *   UNCHOSEN      the user has not answered yet  -> hold at stage one, show the empty state
 *   NO_PROGRAM    the user chose "No Program"    -> reveal the rest, save program = undefined
 *   <program id>  the user chose a program       -> reveal the rest, save that program
 *
 * The old template used `[ngValue]="undefined"` for "No Program", which is indistinguishable from
 * "not answered". Hence an explicit sentinel.
 *
 * WHY `''` AND NOT `null`: `oes-custom-dropdown` coerces null/undefined to `''` in `normalizeInput`
 * on both `writeValue` and its internal change handler, so after the FM9 migration the control can
 * never hold null. Defining the unchosen state as `''` up front means the sentinel survives that
 * migration instead of being silently broken by it two stages later.
 */
export const UNCHOSEN_PROGRAM = '';

/** Explicit "No Program". Mapped to `undefined` on save; never persisted as a literal. */
export const NO_PROGRAM = 'NO_PROGRAM';

/** True when the user has actually answered the program question. */
export const isProgramAnswered = (value: unknown): boolean =>
  value !== UNCHOSEN_PROGRAM && value !== null && value !== undefined;

/** True when the answer was an explicit "No Program". */
export const isNoProgram = (value: unknown): boolean => value === NO_PROGRAM;
